// Written by tools/brand/build.mjs. The mark changes whenever the logo files do.
export type BrandLogo = "emblem" | "lockup-light" | "lockup-dark";

export const brandLogo = (name: BrandLogo): string => `/assets/images/brand-logos/${name}.png?v=3053be906f`;
